import { useCallback } from 'react'
import {
  useUserStore,
  selectIsInternal,
  selectCapabilities,
  selectRole,
} from '@/stores/user.store'

export function useIsInternal() {
  return useUserStore(selectIsInternal)
}

export function useRole() {
  return useUserStore(selectRole)
}

export function useCapabilities() {
  return useUserStore(selectCapabilities)
}

export function useHasCapability(capability: string) {
  const capabilities = useUserStore(selectCapabilities)
  return capabilities.includes(capability)
}

export function useIsAdmin() {
  const role = useUserStore(selectRole)
  return role === 'GREYBULL_ADMIN'
}

export function useCanEditCompany() {
  const capabilities = useUserStore(selectCapabilities)
  const userId = useUserStore((state) => state.profile?.id ?? null)

  return useCallback(
    (primaryOwnerId?: string | null, secondaryOwnerId?: string | null) => {
      if (capabilities.includes('company:edit:all')) return true
      if (!capabilities.includes('company:edit:assigned')) return false
      if (!userId) return false
      return userId === primaryOwnerId || userId === secondaryOwnerId
    },
    [capabilities, userId]
  )
}
